var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7452 12.5576C20.9407 12.3605 21.2593 12.3605 21.4549 12.5575L22.1506 13.2581C22.344 13.4529 22.3442 13.7673 22.1509 13.9623L16.3251 19.8417C16.1295 20.0391 15.8105 20.0391 15.6148 19.8418L12.8493 17.0523C12.6559 16.8573 12.656 16.5428 12.8495 16.348L13.5456 15.6469C13.741 15.4502 14.0592 15.45 14.2548 15.6465L15.97 17.37L20.7452 12.5576ZM10.3536 16.3465C10.1583 16.5417 10.1583 16.8583 10.3536 17.0536L12.1464 18.8465C12.4614 19.1614 12.2383 19.7 11.7929 19.7H3.5C3.22386 19.7 3 19.4762 3 19.2V17.7C3 15.49 6.58 13.7 11 13.7L11.7775 13.7453C12.2084 13.7703 12.4072 14.2928 12.102 14.598L10.3536 16.3465ZM11 3.70001C12.0609 3.70001 13.0783 4.12144 13.8284 4.87158C14.5786 5.62173 15 6.63915 15 7.70001C15 8.76088 14.5786 9.77829 13.8284 10.5284C13.0783 11.2786 12.0609 11.7 11 11.7C9.93913 11.7 8.92172 11.2786 8.17157 10.5284C7.42143 9.77829 7 8.76088 7 7.70001C7 6.63915 7.42143 5.62173 8.17157 4.87158C8.92172 4.12144 9.93913 3.70001 11 3.70001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInLarge);
export default __webpack_public_path__ + "static/media/CheckInLarge.f8fb6ad9a62aa032c1defe375d4a8955.svg";
export { ForwardRef as ReactComponent };